<template>
  <v-sheet width="600" class="px-16 pt-8 pb-6">
    <!-- 제목 -->
    <p class="mb-6 font-weight-bold text-center text-h5">비밀번호 변경</p>

    <p class="mb-4 text-center grey--text text--darken-1">{{ selectedItem.name }} ({{ selectedItem.user_id }})</p>

    <!-- 입력란 -->
    <v-sheet class="mt-2 px-4">
      <v-text-field
        class="rounded-lg mb-4"
        label="새로운 비밀번호"
        dense
        outlined
        hide-details="auto"
        v-model="newPassword"
        type="password"
        :error-messages="newPasswordError"
      ></v-text-field>

      <v-text-field
        class="rounded-lg mb-4"
        label="새로운 비밀번호 확인"
        dense
        outlined
        hide-details="auto"
        v-model="confirmPassword"
        type="password"
        :error-messages="confirmPasswordError"
      ></v-text-field>
    </v-sheet>

    <!-- 버튼 -->
    <div class="d-flex justify-center mt-8">
      <!-- 취소 -->
      <v-btn width="100" color="grey lighten-3" depressed class="font-weight-bold rounded-10 mr-3" @click="close()"> 닫기 </v-btn>

      <!-- 변경 -->
      <v-btn width="100" dark depressed class="font-weight-bold rounded-10" @click="submit()" :loading="saving"> 변경 </v-btn>
    </div>
  </v-sheet>
</template>
<script>
export default {
  props: ["selectedItem"],

  data: () => ({
    newPassword: "",
    confirmPassword: "",
    saving: false,
  }),

  computed: {
    newPasswordError() {
      if (this.newPassword.length > 0 && this.newPassword.length < 4) {
        return "비밀번호는 4자리 이상이어야 합니다."
      }
      return ""
    },
    confirmPasswordError() {
      if (this.confirmPassword.length > 0 && this.newPassword !== this.confirmPassword) {
        return "비밀번호가 일치하지 않습니다."
      }
      return ""
    },
  },

  methods: {
    close() {
      this.newPassword = ""
      this.confirmPassword = ""
      this.$emit("close")
    },

    async submit() {
      if (!this.newPassword) {
        alert("새로운 비밀번호를 입력해주세요.")
        return
      }
      if (this.newPassword.length < 4) {
        alert("비밀번호는 4자리 이상이어야 합니다.")
        return
      }
      if (this.newPassword !== this.confirmPassword) {
        alert("비밀번호가 일치하지 않습니다.")
        return
      }

      this.saving = true
      try {
        const res = await this.$http.post("/api/admin/staff/changePassword", {
          params: {
            id: this.selectedItem.id,
            password: this.newPassword,
          },
        })
        if (res.data.affectedRows) {
          alert("비밀번호가 정상적으로 변경되었습니다.")
          this.$emit("close")
        } else {
          alert("비밀번호 변경 중 오류가 발생하였습니다.")
        }
      } catch (error) {
        console.error("change password error", error)
        alert("비밀번호 변경 중 오류가 발생하였습니다.")
      } finally {
        this.saving = false
      }
    },
  },
}
</script>
